import { ReactComponent as CalendarIcon } from 'app/assets/img/calendar-icon.svg';
import { ReactComponent as TrailingIcon } from 'app/assets/img/iconTrailing.svg';
import InputNumberContainer from 'app/components/InputNumberContainer';
import ContainerFluid from 'app/components/Layout/ContainerFluid';
import useFetchData from 'app/hooks/useFetchData';
import useWindowSize from 'app/hooks/useWindowSize';
import {
  getCommonAirportDataApi,
  getCommonFlightSegmentDataApi,
  getCommonMasterDataApi,
} from 'app/services/holidayApi';
import _ from 'lodash';
import moment from 'moment';
import React, {
  ReactNode,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { objectType } from 'types';
import { objectToSearchParams } from 'utils/helper';
import { getDayOfWeekString } from 'utils/time';
import { selectTranslations } from '../App/slice/selectors';
// import { ValidationMessages } from '../PassengerInfo/constants/messages';
import StyledDatePicker, {
  DatePickerWrapper,
} from '../NewAccount/components/StyledDatePicker';
import { CustomRadioCatalog } from '../Catalog/components/helper';
import AirportSelectPopover from './AirportSelectPopover';
import {
  calculateHotelNights,
  clampAdultCount,
  clampChildCount,
  COMBO_HOLIDAY_TYPES,
  ComboHolidayType,
  getAdultMinForCombo,
  getMaxAdultForCombo,
  getMaxChildForCombo,
  // isPassengerTotalExceeded,
  resolveRoomChangeState,
  getDefaultHotelDates,
  getHotelDisabledDate,
  isAdultDecrementDisabled,
  isHotelCheckoutInvalid,
  isHotelCombo,
  syncHotelDatesWithFlight,
  type Stage,
} from './bookingMask.helpers';
import { BookingMaskWrapper } from './styled';
import { getCookie } from 'utils/cookies';
import { DEFAULT_LANGUAGE, TYPE_COOKIE } from 'utils/constants';

export type { ComboHolidayType, Stage } from './bookingMask.helpers';
export { COMBO_HOLIDAY_TYPES, isHotelCombo } from './bookingMask.helpers';

export const formatDate = (
  date: moment.Moment,
  translation: objectType | undefined,
) => {
  const locale = getCookie(TYPE_COOKIE.LANGUAGE) || DEFAULT_LANGUAGE;
  let formatType = '(DD/MM/YYYY)';
  if (locale === 'en') formatType = '(MM/DD/YYYY)';
  const dayOfWeek = getDayOfWeekString(date, translation);
  // Format the rest of the date
  return `${dayOfWeek} ${date.format(formatType)}`;
};
export type DataStage = {
  label: string;
  value: Stage;
  icon?: ReactNode;
};
export type IFilterHolidaySearch = {
  comboType: ComboHolidayType;
  stage: Stage;
  departure: string;
  departureCode: string;
  destination: string;
  destinationCode: string;
  departureDate: string;
  returnDate: string;
  checkin: string;
  checkout: string;
  adult: number;
  child: number;
  infant: number;
  room: number;
  hotelNights?: number;
  minPrice?: number;
  maxPrice?: number;
  ratings?: string[];
  amenities?: string[];
};
export type TypePoint = 'departure' | 'destination';
export type ErrorDateHoliday = {
  departureDate?: string;
  returnDate?: string;
  hotelDates?: string;
  passengers?: string;
};
interface ICity {
  id: number;
  code: string;
  name: string;
}
interface ICountry {
  id: number;
  code: string;
  name: string;
}
export interface IAirport {
  id: number;
  code: string;
  name: string;
  city: ICity;
  country: ICountry;
  countryName?: string;
  cityName?: string;
}
export interface IItemAirport {
  id: number;
  code: string;
  name: string;
  cityName: string;
  countryName: string;
}
export interface IRegion {
  id: number;
  code: string;
  name: string;
  spaId: number;
  airports: IAirport[];
}
const defaultDepartureDate = moment().format('YYYY-MM-DD');
const defaultHotelDates = getDefaultHotelDates({
  stage: 'round-trip',
  departureDate: defaultDepartureDate,
  returnDate: '',
});

export const DEFAULT_FILTER_SEARCH: IFilterHolidaySearch = {
  comboType: COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL_TICKET,
  stage: 'round-trip',
  departure: '',
  departureCode: '',
  destination: '',
  destinationCode: '',
  departureDate: defaultDepartureDate,
  returnDate: '',
  checkin: defaultHotelDates.checkin,
  checkout: defaultHotelDates.checkout,
  adult: 1,
  child: 0,
  infant: 0,
  room: 1,
};
const hasError = error =>
  Object.values(error).some(v => v !== '' && v !== null && v !== undefined);
export const BookingMask: React.FC = () => {
  const history = useHistory();
  const popupContainer = useRef<HTMLDivElement>(null);
  const popupDestinationContainer = useRef<HTMLDivElement>(null);
  const translations = useSelector(selectTranslations);
  const { device, windowSize } = useWindowSize();
  const [filter, setFilter] = useState<IFilterHolidaySearch>(
    DEFAULT_FILTER_SEARCH,
  );
  const isMobile = device === 'mobile';
  const stage: DataStage[] = [
    {
      label: translations?.['b2b.txt.oneWay'],
      value: 'one-way',
      icon: (
        <i className="fa-solid fa-arrow-right" style={{ fontSize: 12 }}></i>
      ),
    },
    {
      label: translations?.['b2b.txt.roundTrip'],
      value: 'round-trip',
      icon: <TrailingIcon />,
    },
  ];
  const [dataRegions, setDataRegions] = useState<IRegion[]>([]);
  const [dataRegionsDestination, setDataRegionsDestination] = useState<
    IRegion[]
  >([]);
  const [dataAirports, setDataAirports] = useState<IItemAirport[]>([]);
  const [dataSearchAirports, setDataSearchAirports] = useState<IItemAirport[]>(
    [],
  );
  const [regionSelected, setRegionSelected] = useState<IRegion>();
  const [airportSelected, setAirportSelected] = useState<IAirport>();
  const [regionDestinationSelected, setRegionDestinationSelected] =
    useState<IRegion>();
  const [airportDestinationSelected, setAirportDestinationSelected] =
    useState<IAirport>();
  const [isOpenDeparturePoint, setIsOpenDeparturePoint] =
    useState<boolean>(false);
  const [isOpenDestination, setIsOpenDestination] = useState<boolean>(false);
  const [error, setError] = useState<ErrorDateHoliday>({});
  const [textInputDeparture, setTextInputDeparture] = useState<string>('');
  const [isOnChangeDeparture, setIsOnChangeDeparture] =
    useState<boolean>(false);
  const [textInputDestination, setTextInputDestination] = useState<string>('');
  const [isOnChangeDestination, setIsOnChangeDestination] =
    useState<boolean>(false);
  const [dataFlightSegment, setDataFlightSegment] = useState<any>([]);
  const hotelCheckoutErrorMessage = translations?.['b2b.txt.MSG026'];
  useEffect(() => {
    onFetchMasterData();
    onFetchAirport();
  }, []);
  const { onFetchData: onFetchMasterData, isLoading: isLoadingMasterData } =
    useFetchData({
      actionApi: getCommonMasterDataApi,
      IIFE: false,
      onSuccess: response => {
        setDataRegions(response.data.regions);
        setRegionSelected(response.data.regions[0]);
        setRegionDestinationSelected(response.data.regions[0]);
      },
    });
  const { onFetchData: onFetchAirport } = useFetchData({
    actionApi: getCommonAirportDataApi,
    IIFE: false,
    onSuccess: response => {
      setDataAirports(response.data);
      setDataSearchAirports(response.data);
    },
  });
  const {
    onFetchData: onFetchFlightSegment,
    isLoading: isLoadingFlightSegment,
  } = useFetchData({
    actionApi: getCommonFlightSegmentDataApi,
    IIFE: false,
    onSuccess: response => {
      setDataFlightSegment(response.data);
    },
  });
  const onClickRegion = (region: any, type: TypePoint) => {
    if (type === 'departure') {
      setRegionSelected(region);
    } else if (type === 'destination') {
      setRegionDestinationSelected(region);
    }
  };
  useEffect(() => {
    if (airportSelected) {
      const nameText = `${airportSelected.name} (${airportSelected?.code}), ${airportSelected?.countryName}`;
      setTextInputDeparture(nameText);
      setIsOnChangeDeparture(false);
      onFetchFlightSegment({
        payloadData: { departureCode: airportSelected.code },
      });
    }
  }, [airportSelected]);
  useEffect(() => {
    if (airportDestinationSelected) {
      const nameText = `${airportDestinationSelected.name} (${airportDestinationSelected?.code}), ${airportDestinationSelected.countryName}`;
      setTextInputDestination(nameText);
      setIsOpenDestination(false);
    }
  }, [airportDestinationSelected]);
  const findAirportAndRegion = (regions: IRegion[], airportCode: string) => {
    for (const region of regions) {
      const airport = region.airports?.find(a => a.code === airportCode);
      if (airport) {
        return {
          region,
          airport,
        };
      }
    }
    return null;
  };
  const onClickAirport = (airport: any, type: TypePoint) => {
    if (type === 'departure') {
      setAirportSelected(airport);
      setIsOpenDeparturePoint(false);
      setFilter({
        ...filter,
        departure: airport.code,
        departureCode: airport.code,
      });
      if (airport.code === airportDestinationSelected?.code) {
        setAirportDestinationSelected(undefined);
        setTextInputDestination('');
        setRegionDestinationSelected(dataRegions[0]);
      }
      const departureTemp = findAirportAndRegion(dataRegions, airport.code);
      if (departureTemp) {
        setRegionSelected(departureTemp.region);
      }
    } else if (type === 'destination') {
      setAirportDestinationSelected(airport);
      setIsOpenDestination(false);
      if (airport.code === airportSelected?.code) {
        setAirportSelected(undefined);
        setTextInputDeparture('');
        setRegionSelected(dataRegions[0]);
        setFilter({
          ...filter,
          departure: '',
          departureCode: '',
          destination: airport.code,
          destinationCode: airport.code,
        });
      } else {
        setFilter({
          ...filter,
          destination: airport.code,
          destinationCode: airport.code,
        });
      }
      const departureTemp = findAirportAndRegion(
        dataRegionsDestination,
        airport.code,
      );
      if (departureTemp) {
        setRegionDestinationSelected(departureTemp.region);
      }
    }
  };
  const handleOpenChangeDeparturePoint = newOpen => {
    setIsOpenDeparturePoint(newOpen);
    if (!newOpen) {
      if (
        _.isEmpty(airportSelected) ||
        isOnChangeDeparture ||
        !textInputDeparture
      ) {
        setTextInputDeparture('');
        setAirportSelected(undefined);
        setIsOnChangeDeparture(false);
        setTextInputDestination('');
        setAirportDestinationSelected(undefined);
        setIsOnChangeDestination(false);
        setRegionSelected(dataRegions?.[0]);
        setFilter({
          ...filter,
          departure: '',
          departureCode: '',
          destination: '',
          destinationCode: '',
        });
      } else if (airportSelected) {
        const departureTemp = findAirportAndRegion(
          dataRegions,
          airportSelected.code,
        );
        if (departureTemp) {
          setRegionSelected(departureTemp.region);
        }
      }
    }
  };
  const handleOpenChangeDestination = newOpen => {
    setIsOpenDestination(newOpen);
    if (!newOpen) {
      if (_.isEmpty(airportDestinationSelected) || isOnChangeDestination) {
        setTextInputDestination('');
        setAirportDestinationSelected(undefined);
        setIsOnChangeDestination(false);
        setRegionDestinationSelected(dataRegionsDestination?.[0]);
        setFilter({
          ...filter,
          destination: '',
          destinationCode: '',
        });
      } else if (airportDestinationSelected) {
        const departureTemp = findAirportAndRegion(
          dataRegionsDestination,
          airportDestinationSelected.code,
        );
        if (departureTemp) {
          setRegionDestinationSelected(departureTemp.region);
        }
      }
    }
  };
  const comboTypeOptions = [
    {
      value: COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL_TICKET,
      label: translations?.['b2b.txt.comboFlightHotelSunWorld'],
    },
    {
      value: COMBO_HOLIDAY_TYPES.FLIGHT_TICKET,
      label: translations?.['b2b.txt.comboFlightSunWorld'],
    },
    {
      value: COMBO_HOLIDAY_TYPES.FLIGHT_HOTEL,
      label: translations?.['b2b.txt.flightHotelBooking'],
    },
  ];

  const syncHotelDates = useCallback(
    (prev: IFilterHolidaySearch): IFilterHolidaySearch => {
      if (!isHotelCombo(prev.comboType)) return prev;
      return {
        ...prev,
        ...syncHotelDatesWithFlight({
          stage: prev.stage,
          departureDate: prev.departureDate,
          returnDate: prev.returnDate || '',
        }),
      };
    },
    [],
  );

  const onChangeComboType = (comboType: ComboHolidayType) => {
    setError(prev => ({ ...prev, hotelDates: '' }));
    setFilter(prev => {
      const next = { ...prev, comboType };
      if (!isHotelCombo(comboType)) return next;
      if (
        next.departureDate &&
        next.returnDate &&
        moment(next.returnDate).isSame(moment(next.departureDate), 'day')
      ) {
        next.returnDate = moment(next.departureDate)
          .add(1, 'day')
          .format('YYYY-MM-DD');
      }
      const withHotelDates = syncHotelDates(next);
      return {
        ...withHotelDates,
        adult: clampAdultCount(
          withHotelDates.adult,
          comboType,
          withHotelDates.room,
          withHotelDates.child,
        ),
      };
    });
  };

  const onChangeComboTypeFromEvent = (e: {
    target: { value: ComboHolidayType };
  }) => {
    onChangeComboType(e.target.value);
  };

  const onChangeStage = (stage: Stage) => {
    if (stage === 'one-way') {
      setError({ ...error, departureDate: '', returnDate: '', hotelDates: '' });
    } else if (stage === 'round-trip') {
      setError({
        ...error,
        hotelDates: '',
      });
      if (filter.departureDate && filter.returnDate) {
        const departure = moment(filter.departureDate);
        const returnDate = moment(filter.returnDate);
        if (departure.isValid() && returnDate.isValid()) {
          if (departure.isAfter(returnDate)) {
            setError({
              ...error,
              returnDate:
                translations?.['b2b.txt.returnDateMustBeAfterDeparture'],
            });
            setFilter({ ...filter });
          }
        }
      }
    }
    setFilter(prev => syncHotelDates({ ...prev, stage }));
  };

  const onChangeDepartureDate = (date: moment.Moment | null) => {
    if (date) {
      const departureDate = date.format('YYYY-MM-DD');
      if (
        isHotelCombo(filter.comboType) &&
        filter.returnDate &&
        date.isSame(moment(filter.returnDate), 'day')
      ) {
        setFilter(prev =>
          syncHotelDates({
            ...prev,
            departureDate,
            returnDate: moment(date).add(1, 'day').format('YYYY-MM-DD'),
          }),
        );
        setError(prev => ({
          ...prev,
          departureDate: '',
          returnDate: '',
          hotelDates: '',
        }));
        return;
      }
      if (
        filter.stage === 'round-trip' &&
        filter.returnDate &&
        date.isAfter(moment(filter.returnDate))
      ) {
        setError(prev => ({
          ...prev,
          returnDate: translations?.['b2b.txt.returnDateMustBeAfterDeparture'],
          hotelDates: '',
        }));
        setFilter(prev =>
          syncHotelDates({
            ...prev,
            departureDate: date.format('YYYY-MM-DD'),
          }),
        );
        return;
      }
      setFilter(prev =>
        syncHotelDates({
          ...prev,
          departureDate: date.format('YYYY-MM-DD'),
        }),
      );
      setError(prev => ({
        ...prev,
        departureDate: '',
        returnDate: '',
        hotelDates: '',
      }));
    } else {
      setFilter(prev => syncHotelDates({ ...prev, departureDate: '' }));
      setError(prev => ({ ...prev, departureDate: '', hotelDates: '' }));
    }
  };

  const onChangeReturnDate = (date: moment.Moment | null) => {
    if (date) {
      if (filter.departureDate && date.isBefore(moment(filter.departureDate))) {
        setError(prev => ({
          ...prev,
          returnDate: translations?.['b2b.txt.returnDateMustBeAfterDeparture'],
        }));
        setFilter(prev => ({ ...prev, returnDate: '' }));
        return;
      }
      if (
        filter.departureDate &&
        date.isSameOrAfter(moment(filter.departureDate))
      ) {
        setError(prev => ({
          ...prev,
          departureDate: '',
          returnDate: '',
          hotelDates: '',
        }));
        setFilter(prev =>
          syncHotelDates({
            ...prev,
            returnDate: date.format('YYYY-MM-DD'),
          }),
        );
        if (
          date.isSame(moment(filter.departureDate), 'day') &&
          isHotelCombo(filter.comboType)
        ) {
          setError(prev => ({
            ...prev,
            hotelDates: hotelCheckoutErrorMessage,
          }));
        }
        return;
      }
      setFilter(prev =>
        syncHotelDates({
          ...prev,
          returnDate: date.format('YYYY-MM-DD'),
        }),
      );
    } else {
      setFilter(prev => syncHotelDates({ ...prev, returnDate: '' }));
    }
  };

  const hotelDisabledDate = (current: moment.Moment) =>
    getHotelDisabledDate({
      stage: filter.stage,
      departureDate: filter.departureDate,
      returnDate: filter.returnDate,
    })(current);

  const onChangeCheckInDate = (date: moment.Moment | null) => {
    if (!date) {
      setFilter(prev => ({ ...prev, checkin: '', checkout: '' }));
      setError(prev => ({ ...prev, hotelDates: '' }));
      return;
    }
    const checkin = date.format('YYYY-MM-DD');
    setFilter(prev => {
      const checkoutInvalid = isHotelCheckoutInvalid(checkin, prev.checkout);
      setError(err => ({
        ...err,
        hotelDates: checkoutInvalid ? hotelCheckoutErrorMessage : '',
      }));
      return { ...prev, checkin };
    });
  };

  const onChangeCheckOutDate = (date: moment.Moment | null) => {
    if (!date) {
      setFilter(prev => ({ ...prev, checkout: '' }));
      setError(prev => ({ ...prev, hotelDates: '' }));
      return;
    }
    const checkout = date.format('YYYY-MM-DD');
    setFilter(prev => {
      const checkoutInvalid =
        !prev.checkin || isHotelCheckoutInvalid(prev.checkin, checkout);
      setError(err => ({
        ...err,
        hotelDates: checkoutInvalid ? hotelCheckoutErrorMessage : '',
      }));
      return { ...prev, checkout };
    });
  };

  // const passengerLimitMessage = translations?.['b2b.txt.MSG002'];

  // const syncPassengerError = (
  //   adult: number,
  //   child: number,
  //   passengerLimitError: boolean,
  // ) => {
  //   setError(err => ({
  //     ...err,
  //     passengers:
  //       passengerLimitError && isPassengerTotalExceeded(adult, child)
  //         ? passengerLimitMessage
  //         : !isPassengerTotalExceeded(adult, child)
  //         ? ''
  //         : err.passengers,
  //   }));
  // };

  // useEffect(() => {
  //   if (!isPassengerTotalExceeded(filter.adult, filter.child)) {
  //     setError(prev => (prev.passengers ? { ...prev, passengers: '' } : prev));
  //   }
  // }, [filter.adult, filter.child]);

  const handleChangeRoom = (value: number) => {
    setFilter(prev => {
      const { room, adult, child } = resolveRoomChangeState(
        value,
        prev.adult,
        prev.child,
      );
      return {
        ...prev,
        room,
        adult,
        child,
      };
    });
  };
  const handleChangeAdult = (value: number) => {
    setFilter(prev => {
      const adult = clampAdultCount(
        value,
        prev.comboType,
        prev.room,
        prev.child,
      );
      // syncPassengerError(adult, prev.child, false);
      return { ...prev, adult };
    });
  };
  const handleChangeChild = (value: number) => {
    setFilter(prev => {
      const child = clampChildCount(
        value,
        prev.adult,
        prev.comboType,
        prev.room,
      );
      // syncPassengerError(prev.adult, child, false);
      return { ...prev, child };
    });
  };
  const handleChangeInfant = value => {
    setFilter({ ...filter, infant: value });
  };
  const onClickSearch = () => {
    const query = objectToSearchParams({
      ...filter,
      ...(isHotelCombo(filter.comboType) && filter.checkin && filter.checkout
        ? {
            hotelNights: calculateHotelNights(filter.checkin, filter.checkout),
          }
        : {}),
    });
    history.push(`/holiday?${query}`);
  };
  const onSwapPoint = () => {
    if (filter.departure && filter.destination) {
      setFilter({
        ...filter,
        departure: filter.destination,
        destination: filter.departure,
      });
      const departureTemp = findAirportAndRegion(
        dataRegions,
        filter.destination,
      );
      if (departureTemp) {
        setRegionSelected(departureTemp.region);
        setAirportSelected(departureTemp.airport);
      }
    }
  };
  const handleInputChange =
    (type: 'departure' | 'destination') => (event: any) => {
      if (type === 'departure') {
        setIsOpenDeparturePoint(true);
        if (event.target.value) {
          // Clear selected value while user is typing so re-selecting
          // the same airport still triggers state updates/effects.
          setAirportSelected(undefined);
          setTextInputDeparture(event.target.value);
          setIsOnChangeDeparture(true);
        } else {
          setAirportSelected(undefined);
          setIsOnChangeDeparture(false);
          setTextInputDeparture('');
          setFilter(prev => ({
            ...prev,
            departure: '',
            departureCode: '',
            destination: '',
            destinationCode: '',
          }));
        }
      } else if (type === 'destination') {
        setIsOpenDestination(true);
        if (event.target.value) {
          setAirportDestinationSelected(undefined);
          setTextInputDestination(event.target.value);
          setIsOnChangeDestination(true);
        } else {
          setAirportDestinationSelected(undefined);
          setIsOnChangeDestination(false);
          setTextInputDestination('');
          setFilter(prev => ({
            ...prev,
            destination: '',
            destinationCode: '',
          }));
        }
      }
    };
  useEffect(() => {
    if (dataFlightSegment) {
      const arrivalCodeSet = new Set(
        dataFlightSegment.map(item => item.arrivalCode),
      );
      const dataRegionDestinationTemp = dataRegions?.map(region => ({
        ...region,
        airports: region.airports.filter(airport =>
          arrivalCodeSet.has(airport.code),
        ),
      }));
      setDataRegionsDestination(dataRegionDestinationTemp);
      setRegionDestinationSelected(dataRegionDestinationTemp[0]);
    }
  }, [dataFlightSegment]);
  useEffect(() => {
    if (dataRegionsDestination) {
      const destinationTemp = findAirportAndRegion(
        dataRegionsDestination,
        filter.destination,
      );
      if (destinationTemp) {
        setRegionDestinationSelected(destinationTemp.region);
        setAirportDestinationSelected(destinationTemp.airport);
      } else {
        setTextInputDestination('');
        setAirportDestinationSelected(undefined);
        setIsOnChangeDestination(false);
        setRegionDestinationSelected(dataRegionsDestination?.[0]);
        setFilter({
          ...filter,
          destination: '',
          destinationCode: '',
        });
      }
    }
  }, [dataRegionsDestination]);

  const showHotelFields = isHotelCombo(filter.comboType);
  const adultMin = getAdultMinForCombo(filter.comboType, filter.room);
  const adultMax = getMaxAdultForCombo(
    filter.child,
    filter.comboType,
    filter.room,
  );
  const childMax = getMaxChildForCombo(
    filter.adult,
    filter.comboType,
    filter.room,
  );
  const isDisableMinusAdult = isAdultDecrementDisabled(
    filter.adult,
    filter.comboType,
    filter.room,
  );
  const hotelNights = calculateHotelNights(filter.checkin, filter.checkout);
  return (
    <ContainerFluid>
      <BookingMaskWrapper>
        <div className="boxSearch">
          <BoxItemSearch className="comboHolidaySection">
            <div className="title">
              {translations?.['b2b.txt.selectHolidayCombo']}
            </div>
            <div
              className="comboTypeBar"
              role="radiogroup"
              style={{ width: isMobile ? '100%' : '100%' }}
            >
              {CustomRadioCatalog(
                comboTypeOptions,
                filter.comboType,
                onChangeComboTypeFromEvent,
                { fontSize: 13, lineHeight: 1.35 },
              )}
            </div>
          </BoxItemSearch>
          <BoxItemSearch className="gap-3" style={{ paddingRight: 14 }}>
            {stage.map(item => {
              return (
                <div
                  key={item.value}
                  className="boxRadio"
                  data-active={filter.stage === item.value}
                  onClick={() => onChangeStage(item.value)}
                >
                  {item.icon}
                  {item.label}
                </div>
              );
            })}
          </BoxItemSearch>
          <BoxItemSearch>
            <AirportSelectPopover
              type="departure"
              isOpen={isOpenDeparturePoint}
              onOpenChange={handleOpenChangeDeparturePoint}
              textValue={textInputDeparture}
              onTextChange={handleInputChange('departure')}
              isSearching={isOnChangeDeparture}
              regions={dataRegions}
              selectedRegion={regionSelected}
              selectedAirport={airportSelected}
              excludedAirportCode={airportDestinationSelected?.code}
              dataSearchAirports={dataSearchAirports}
              onSelectRegion={region => onClickRegion(region, 'departure')}
              onSelectAirport={airport => onClickAirport(airport, 'departure')}
              popupContainerRef={popupContainer}
              device={device}
              windowWidth={windowSize.width}
              placeholder={translations?.['b2b.txt.selectDeparturePoint']}
              isDisabled={false}
              isLoading={isLoadingMasterData}
            />

            <div className="boxColumnDivider">
              <div className="boxTrailing" onClick={onSwapPoint}>
                <TrailingIcon />
              </div>
            </div>
            <AirportSelectPopover
              type="destination"
              isOpen={isOpenDestination}
              onOpenChange={handleOpenChangeDestination}
              textValue={textInputDestination}
              onTextChange={handleInputChange('destination')}
              isSearching={isOnChangeDestination}
              regions={dataRegionsDestination}
              selectedRegion={regionDestinationSelected}
              selectedAirport={airportDestinationSelected}
              excludedAirportCode={airportSelected?.code}
              dataSearchAirports={dataSearchAirports}
              onSelectRegion={region => onClickRegion(region, 'destination')}
              onSelectAirport={airport =>
                onClickAirport(airport, 'destination')
              }
              popupContainerRef={popupDestinationContainer}
              device={device}
              windowWidth={windowSize.width}
              placeholder={translations?.['b2b.txt.selectDestination']}
              isDisabled={!textInputDeparture && !isLoadingFlightSegment}
              isLoading={isLoadingFlightSegment}
            />
          </BoxItemSearch>
          <BoxItemSearch
            height={
              isMobile
                ? 'auto'
                : error.departureDate || error.returnDate
                ? '70px'
                : '50px'
            }
            isMobile={isMobile}
          >
            <div className="boxDate" style={{ width: '100%' }}>
              <CalendarIcon />
              <div style={{ width: '100%' }}>
                <DatePickerWrapper>
                  <StyledDatePicker
                    className="dataPicker"
                    dropdownClassName="custom-date-popup"
                    getPopupContainer={trigger => trigger.parentElement!}
                    suffixIcon={<></>}
                    placeholder={translations?.['b2b.txt.selectDepartureDate']}
                    format={date => formatDate(date, translations)}
                    allowClear
                    disabledDate={current =>
                      current && current < moment().startOf('day')
                    }
                    value={
                      moment(filter.departureDate).isValid()
                        ? moment(filter.departureDate)
                        : null
                    }
                    onChange={onChangeDepartureDate}
                  />
                </DatePickerWrapper>
                {error.departureDate && (
                  <TextError>{error.departureDate}</TextError>
                )}
              </div>
            </div>
            {filter.stage === 'round-trip' && (
              <>
                <div className="boxColumnDivider" />
                <div
                  className="boxDate align-items-start flex-column gap-0"
                  style={{
                    paddingLeft: isMobile ? 0 : 14,
                    width: '100%',
                  }}
                >
                  <div className="boxDate" style={{ width: '100%' }}>
                    <CalendarIcon />
                    <div style={{ width: '100%' }}>
                      <DatePickerWrapper>
                        <StyledDatePicker
                          className="dataPicker"
                          dropdownClassName="custom-date-popup"
                          getPopupContainer={trigger => trigger.parentElement!}
                          suffixIcon={<></>}
                          placeholder={
                            translations?.['b2b.txt.selectReturnDate']
                          }
                          format={date => formatDate(date, translations)}
                          allowClear
                          disabledDate={current => {
                            if (!current) return false;
                            if (current < moment().startOf('day')) return true;
                            if (filter.departureDate) {
                              const departure = moment(filter.departureDate);
                              if (departure.isValid()) {
                                if (isHotelCombo(filter.comboType)) {
                                  return current.isSameOrBefore(
                                    departure.startOf('day'),
                                    'day',
                                  );
                                }
                                // return current < departure.startOf('day');
                                return current.isBefore(
                                  departure.startOf('day'),
                                  'day',
                                );
                              }
                            }
                            return false;
                          }}
                          value={
                            moment(filter.returnDate).isValid()
                              ? moment(filter.returnDate)
                              : null
                          }
                          onChange={onChangeReturnDate}
                        />
                      </DatePickerWrapper>
                    </div>
                  </div>
                  {error.returnDate && (
                    <TextError>{error.returnDate}</TextError>
                  )}
                </div>
              </>
            )}
          </BoxItemSearch>
          {showHotelFields && (
            <>
              <BoxItemSearch
                isMobile={isMobile}
                height={isMobile ? 'auto' : '50px'}
              >
                <div className="boxDate">
                  <CalendarIcon />
                  <div style={{ width: '100%' }}>
                    <DatePickerWrapper>
                      <StyledDatePicker
                        className="dataPicker"
                        dropdownClassName="custom-date-popup"
                        getPopupContainer={trigger => trigger.parentElement!}
                        suffixIcon={<></>}
                        placeholder={translations?.['b2b.txt.hotelCheckIn']}
                        format={date => formatDate(date, translations)}
                        allowClear
                        disabledDate={current =>
                          current ? hotelDisabledDate(current) : false
                        }
                        value={
                          moment(filter.checkin).isValid()
                            ? moment(filter.checkin)
                            : null
                        }
                        onChange={onChangeCheckInDate}
                      />
                    </DatePickerWrapper>
                  </div>
                </div>
                <div className="boxColumnDivider" />
                <div
                  className="boxDate"
                  style={{ paddingLeft: isMobile ? 0 : 14, flex: 1 }}
                >
                  <CalendarIcon />
                  <DatePickerWrapper>
                    <StyledDatePicker
                      className="dataPicker"
                      dropdownClassName="custom-date-popup"
                      getPopupContainer={trigger => trigger.parentElement!}
                      suffixIcon={<></>}
                      placeholder={translations?.['b2b.txt.hotelCheckOut']}
                      format={date => formatDate(date, translations)}
                      allowClear
                      disabledDate={current => {
                        if (!current) return false;
                        if (hotelDisabledDate(current)) return true;
                        if (filter.checkin) {
                          const checkIn = moment(filter.checkin);
                          if (
                            checkIn.isValid() &&
                            current.isSameOrBefore(checkIn, 'day')
                          ) {
                            return true;
                          }
                        }
                        return false;
                      }}
                      value={
                        moment(filter.checkout).isValid()
                          ? moment(filter.checkout)
                          : null
                      }
                      onChange={onChangeCheckOutDate}
                    />
                  </DatePickerWrapper>
                </div>
                {hotelNights > 0 && (
                  <span
                    className="nightsBadge"
                    style={{
                      marginLeft: isMobile ? 0 : 'auto',
                    }}
                  >
                    {hotelNights} {translations?.['b2b.txt.nights']}
                  </span>
                )}
                <div className="boxColumnDivider" />
                <div
                  className="hotelRoomSection"
                  style={{
                    paddingLeft: isMobile ? 0 : 10,
                    width: isMobile ? '100%' : 'auto',
                    paddingRight: isMobile ? 0 : 10,
                  }}
                >
                  <div className="sub-title">
                    {translations?.['b2b.txt.roomQuantity']}
                  </div>
                  <div
                    className="form-inputNumber"
                    style={{
                      marginLeft: isMobile ? 'auto' : 0,
                      marginBottom: isMobile ? 10 : 0,
                    }}
                  >
                    <InputNumberContainer
                      value={filter.room}
                      onChange={value => handleChangeRoom(value)}
                      min={1}
                      max={5}
                      isDisableMinus={filter.room <= 1}
                      isRunChangeEventWithSameValue
                      isSyncValuePropAndCompValueWhenTextValueEmpty
                    />
                  </div>
                </div>
              </BoxItemSearch>
              {error.hotelDates && (
                <FieldErrorBar>
                  <TextError>{error.hotelDates}</TextError>
                </FieldErrorBar>
              )}
            </>
          )}
          <BoxItemSearch
            style={{
              gap: 30,
              flexWrap: 'wrap',
              marginTop: device === 'desktop' ? 0 : 10,
              height: device === 'desktop' ? '50px' : 'auto',
              alignItems: device === 'desktop' ? 'center' : 'flex-start',
            }}
          >
            <div
              className="d-flex gap-3"
              style={{ width: device === 'desktop' ? 'auto' : '100%' }}
            >
              <div>
                <div className="sub-title">
                  {translations?.['b2b.txt.adult']}
                </div>
                <div className="note-title">
                  {translations?.['b2b.txt.adultAge']}
                </div>
              </div>
              <div
                className="form-inputNumber"
                style={{ marginLeft: device === 'desktop' ? 0 : 'auto' }}
              >
                <InputNumberContainer
                  value={filter.adult}
                  onChange={value => handleChangeAdult(value)}
                  min={adultMin}
                  max={adultMax}
                  isDisableMinus={isDisableMinusAdult}
                  isRunChangeEventWithSameValue
                  isSyncValuePropAndCompValueWhenTextValueEmpty
                />
              </div>
            </div>
            <div
              className="d-flex gap-3"
              style={{ width: device === 'desktop' ? 'auto' : '100%' }}
            >
              <div>
                <div className="sub-title">
                  {translations?.['b2b.txt.child']}
                </div>
                <div className="note-title">
                  {translations?.['b2b.txt.childAge']}
                </div>
              </div>
              <div
                className="form-inputNumber"
                style={{ marginLeft: device === 'desktop' ? 0 : 'auto' }}
              >
                <InputNumberContainer
                  value={filter.child}
                  onChange={value => handleChangeChild(value)}
                  min={0}
                  max={childMax}
                  isRunChangeEventWithSameValue
                  isSyncValuePropAndCompValueWhenTextValueEmpty
                />
              </div>
            </div>
            <div
              className="d-flex gap-3"
              style={{ width: device === 'desktop' ? 'auto' : '100%' }}
            >
              <div>
                <div className="sub-title">
                  {translations?.['b2b.txt.infant']}
                </div>
                <div className="note-title">
                  {translations?.['b2b.txt.infantAge']}
                </div>
              </div>
              <div
                className="form-inputNumber"
                style={{ marginLeft: device === 'desktop' ? 0 : 'auto' }}
              >
                <InputNumberContainer
                  value={filter.infant}
                  onChange={value => handleChangeInfant(value)}
                  min={0}
                  max={+filter.adult}
                  isRunChangeEventWithSameValue
                  isSyncValuePropAndCompValueWhenTextValueEmpty
                />
              </div>
            </div>
          </BoxItemSearch>
          {/* {error.passengers && (
            <FieldErrorBar>
              <TextError>{error.passengers}</TextError>
            </FieldErrorBar>
          )} */}
          <ButtonSearch
            disabled={
              !filter.departure ||
              !filter.destination ||
              !filter.departureDate ||
              !textInputDeparture ||
              !textInputDestination ||
              hasError(error) ||
              (filter.stage === 'round-trip' && !filter.returnDate) ||
              (showHotelFields &&
                (!filter.checkin || !filter.checkout || !!error.hotelDates))
            }
            onClick={onClickSearch}
          >
            {translations?.['b2c.txt.search']}
          </ButtonSearch>
        </div>
        <div
          style={{
            marginTop: 20,
            width: '100%',
            objectFit: 'cover',
          }}
        >
          <img
            style={{ width: '100%' }}
            src={require('app/assets/img/bannerComboHoliday.png')}
            alt=""
          />
        </div>
      </BookingMaskWrapper>
    </ContainerFluid>
  );
};
const BoxItemSearch = styled.div<{ height?: string; isMobile?: boolean }>`
  height: ${props => props.height ?? '50px'};
  border-bottom: 1px solid #e5e5e5;
  padding-left: 14px;
  display: flex;
  flex-direction: ${props => (props.isMobile ? 'column' : 'row')};
  align-items: ${props => (props.isMobile ? 'flex-start' : 'center')};
`;
const TextError = styled.div`
  font-size: 12px;
  color: red;
  line-height: 1.4;
`;
const FieldErrorBar = styled.div`
  padding: 4px 14px 10px;
  border-bottom: 1px solid #e5e5e5;
  background: #f5f5f55c;
`;

const ButtonSearch = styled.button`
  height: 50px;
  background: var(--color-gradient);
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  border: 1px solid #e5e5e5;
  &:hover {
    opacity: 0.8;
  }
  &:disabled {
    background: #d4d4d4;
    color: #444444;
    cursor: not-allowed;
    opacity: 1;
  }
`;
